import * as url from 'url'

import reportError from 'airship/modules/report-error'
import closest from 'airship/modules/closest'
import getJson from 'airship/modules/get-json'

interface AnnouncementResponse {
  ok: boolean
}

function init(): void {
  const els = document.querySelectorAll('.announcement_mark_read a')
  els.forEach((el) => {
    el.addEventListener('click', handleClick)
  })

  function handleClick(evt: Event): void {
    evt.preventDefault()
    evt.stopPropagation()

    const target = evt.target || evt.srcElement
    if (!target) {
      return reportError(new Error('No target element on event'))
    }

    try {
      markAsRead(target as HTMLElement)
    } catch (err) {
      reportError(err, {extra: {target}})
    }
  }
}

function markAsRead(clickedEl: HTMLElement): void {
  const announcementElement = closest(
    clickedEl,
    'div.dm-feedback'
  ) as HTMLElement
  const anchor = closest(clickedEl, 'a')
  if (!anchor) {
    return reportError(new Error('Announcement anchor not found'), {
      extra: {
        clickedEl,
      },
    })
  }

  const href = anchor.getAttribute('href') || ''
  // This url has an `?next=<url>` querystring, which we don't want. Grab just
  // the path, and append a querystring that lets the backend know this is JS
  // talking.
  const path = url.parse(href).pathname + '?isAjax=true'
  getJson<AnnouncementResponse>(path)
    .then((data) => {
      if (data.ok) {
        announcementElement?.parentElement?.removeChild(announcementElement)
        return
      }
      reportError(new Error(`Announcement mark-read request failed`), {
        extra: {resp: data},
      })
    })
    .catch((err: Error) => {
      reportError(err, {extra: {href}})
    })
}

init()
